import angular from 'angular';

import ForgotPasswordRequestComponent from './forgot-password-request.cmpt';

export default angular
    .module('application.scene.identity.scene.forgot-password-request', [])
    .component(ForgotPasswordRequestComponent.selector, ForgotPasswordRequestComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.forgot-password.request', {
        url: '',
        template: '<db-a-forgot-password-request class="block-component"></db-a-forgot-password-request>',
        params: {
            email: null
        }
    });
}




// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/scene/forgot-password-request/index.js